import React from 'react';
import styled from 'styled-components';
import { Tooltip, Typography } from '@material-ui/core';
import { ThemeProvider, SvgWrapper } from '@nivo/core';
import { BoxLegendSvg } from '@nivo/legends';
const StyledDiv = styled.div `
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
  justify-content: center;
  row-gap: 8px;
  column-gap: 2px;
  .legend-item {
    display: flex;
    cursor: default;
    align-items: center;
    border-radius: 18px;
    padding: 2px 8px 2px 6px;
    transition: background-color 300ms cubic-bezier(0.075, 0.82, 0.165, 1);
    &:hover {
      background-color: ${props => props.theme.palette.action.hover};
    }
    & > svg {
      margin-right: 8px;
    }
    &.clickable {
      cursor: pointer;
    }
    .label {
      font-size: 11px;
      max-width: 140px;
      overflow-x: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      transition: color 300ms cubic-bezier(0.075, 0.82, 0.165, 1);
    }
    &:hover .label {
      color: ${props => props.theme.palette.text.primary};
    }
  }
`;
export function ChartLegends(props) {
    const { stats, className, onItemClick, activeId } = props;
    const classes = ['chart-legends'];
    className && classes.push(className);
    const itemClasses = ['legend-item'];
    onItemClick && itemClasses.push('clickable');
    return (React.createElement(StyledDiv, { className: classes.join(' ') },
        React.createElement(ThemeProvider, null, stats.map((stat, index) => (React.createElement(Tooltip, { arrow: true, placement: 'top', key: `legend-${stat.id}-${index}`, title: stat.tooltipText || `${stat.id}: ${stat.value}` },
            React.createElement("div", { style: { opacity: activeId && activeId !== stat.id ? 0.3 : 1 }, className: itemClasses.join(' '), onClick: () => onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick(stat, index) },
                React.createElement(SvgWrapper, { width: 18, height: 18, margin: { top: 0, bottom: 0, right: 0, left: 0 } },
                    React.createElement(BoxLegendSvg, { onClick: () => { }, data: [Object.assign(Object.assign({}, stat), { label: '' })], anchor: 'top', direction: 'row', containerWidth: 120, containerHeight: 18, itemWidth: 120, itemHeight: 18, itemOpacity: 0.85, symbolShape: 'circle', symbolSize: 18, itemTextColor: '#999', effects: [{ on: 'hover', style: { itemTextColor: '#000' } }] })),
                React.createElement(Typography, { variant: 'body2', className: 'label', color: 'textSecondary' }, stat.label))))))));
}
export default ChartLegends;
//# sourceMappingURL=ChartLegends.js.map